import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import { useSectionNav } from "./useSectionNav";

const motionBase =
  "transition-[transform,box-shadow,background-color,color,border-color] duration-200 ease-out active:translate-y-0 active:scale-[0.98]";
const focusBase =
  "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-lilac focus-visible:ring-offset-2";

export const PrimaryButton = ({ children, onClick, testId, className = "", type = "button" }) => (
  <button
    type={type}
    data-testid={testId}
    onClick={onClick}
    className={`group inline-flex items-center justify-center gap-2.5 rounded-full bg-lilac px-7 py-3.5 text-sm font-bold text-ink shadow-[0_10px_28px_-12px_rgba(184,167,232,0.55)] hover:-translate-y-0.5 hover:bg-lilac-bright hover:shadow-[0_18px_38px_-12px_rgba(184,167,232,0.6)] ${motionBase} ${focusBase} focus-visible:ring-offset-ink ${className}`}
  >
    <span>{children}</span>
    <ArrowRight className="h-4 w-4 transition-transform duration-200 ease-out group-hover:translate-x-1" aria-hidden="true" />
  </button>
);

// `target` accepts a route ("/checklist") or an on-page section id ("included").
export const DarkButton = ({ children, onClick, target, testId, className = "" }) => {
  const sectionNav = useSectionNav();
  const cls = `group inline-flex items-center justify-center gap-2.5 rounded-full bg-ink px-7 py-3.5 text-sm font-bold text-paper shadow-[0_10px_24px_-12px_rgba(0,0,0,0.7)] hover:-translate-y-0.5 hover:bg-[#2b2c3e] hover:shadow-[0_18px_36px_-12px_rgba(0,0,0,0.75)] ${motionBase} ${focusBase} focus-visible:ring-ink focus-visible:ring-offset-lilac ${className}`;
  const inner = (
    <>
      <span>{children}</span>
      <ArrowRight className="h-4 w-4 transition-transform duration-200 ease-out group-hover:translate-x-1" aria-hidden="true" />
    </>
  );
  if (target?.startsWith("/")) {
    return (
      <Link to={target} data-testid={testId} onClick={onClick} className={cls}>
        {inner}
      </Link>
    );
  }
  if (target) {
    return (
      <a href={`/#${target}`} data-testid={testId} onClick={sectionNav(target)} className={cls}>
        {inner}
      </a>
    );
  }
  return (
    <button type="button" data-testid={testId} onClick={onClick} className={cls}>
      {inner}
    </button>
  );
};

export const ArrowLink = ({ children, target, testId, className = "" }) => {
  const sectionNav = useSectionNav();
  const cls = `group relative inline-flex w-fit items-center gap-2 rounded-sm pb-1 text-sm font-bold text-lilac after:absolute after:bottom-0 after:left-0 after:h-px after:w-full after:origin-left after:scale-x-0 after:bg-current after:transition-transform after:duration-200 after:ease-out hover:text-lilac-bright hover:after:scale-x-100 ${focusBase} focus-visible:ring-offset-ink ${className}`;
  const inner = (
    <>
      <span>{children}</span>
      <ArrowRight className="h-4 w-4 transition-transform duration-200 ease-out group-hover:translate-x-1" aria-hidden="true" />
    </>
  );
  if (target?.startsWith("/")) {
    return (
      <Link to={target} data-testid={testId} className={cls}>
        {inner}
      </Link>
    );
  }
  return (
    <a href={`/#${target}`} data-testid={testId} onClick={sectionNav(target)} className={cls}>
      {inner}
    </a>
  );
};
